module.exports = __webpack_public_path__ + "static/media/export.d5396823.svg";